// extracted by mini-css-extract-plugin
module.exports = {"World":"worlds_World__2EBhd","Image":"worlds_Image__2kliM","Table":"worlds_Table__1g-ft","DangerIcon":"worlds_DangerIcon__38Li2"};